/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Register_Onboarding_Personal_Info_ProcessingInputs */

const en_register_onboarding_personal_info_processing = /** @type {(inputs: Register_Onboarding_Personal_Info_ProcessingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The resume is being processed. Please wait…`)
};

const de_register_onboarding_personal_info_processing = /** @type {(inputs: Register_Onboarding_Personal_Info_ProcessingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Der Lebenslauf wird verarbeitet. Bitte warten…`)
};

/**
* | output |
* | --- |
* | "The resume is being processed. Please wait…" |
*
* @param {Register_Onboarding_Personal_Info_ProcessingInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const register_onboarding_personal_info_processing = /** @type {((inputs?: Register_Onboarding_Personal_Info_ProcessingInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Register_Onboarding_Personal_Info_ProcessingInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_register_onboarding_personal_info_processing(inputs)
	return en_register_onboarding_personal_info_processing(inputs)
});